import { toast } from 'react-toastify';
const HOST = process.env.REACT_APP_API_ENDPOINT
const getBid = () => {
  const newSearchParams = new URLSearchParams(window.location.search);
  return newSearchParams.get("bid");
}

class CQAPI {
  init() {}
  async performRequest(method, endpoint, body) {
    const requestOptions = {
      headers: {
        ...body instanceof FormData ? {} : {
          'Content-Type': 'application/json'
        },
        ...this.user && this.user.token ? {
          Authorization: `Bearer ${this.user.token}`
        } : {}
      },
      method,
      withCredentials: true,
      ...body ? {
        ...body instanceof FormData ? {
          body: body
        } : {
          body: JSON.stringify(body)
        }
      } : {}
    };


    try {
      const response = await fetch(`${HOST}${endpoint}`, requestOptions).then(response => response.json())
      return response;
    } catch (error) {
      return error.response; // Handle the error response
    }
  }

  async errorHandler(response, method, endpoint, body) {
    if (response.type === 'error' && !response.code && (response.msg || response.message)){
      toast.error((response.msg || response.message));
    }
    return response;
  }

  getEndpoint(ep) {
    const bid = getBid()
    return bid && !ep.includes('bid=') ? `${ep}${ep.includes('?')?'&':'?'}bid=${bid}` : `${ep}`;
  }

  async post(ep, body) {
    body = body || {}
    const endpoint = this.getEndpoint(ep);
    const response = await this.performRequest('post', endpoint, body);
    return this.errorHandler(response, 'post', endpoint, body);
  }

  async get(ep) {
    const endpoint = this.getEndpoint(ep);
    const response = await this.performRequest('get', endpoint);
    return this.errorHandler(response, 'get', endpoint);
  }
  async del(ep, body) {
    const endpoint = this.getEndpoint(ep);
    const response = await this.performRequest('delete', endpoint, body);
    return this.errorHandler(response, 'del', endpoint, body);
  }
  async put(ep, body) {
    const endpoint = this.getEndpoint(ep);
    const response = await this.performRequest('put', endpoint, body);
    return this.errorHandler(response, 'put', endpoint, body);
  }
}


const cqAPI = new CQAPI()


export {
  cqAPI,
  getBid,
  HOST
};
